import { ResultadoAgendamento } from "./ResultadoAgendamento";

export default ResultadoAgendamento;